module.exports = __webpack_public_path__ + "static/bgRight-647cec2ca88aabd6e81d6c14f085bd77.png";